import { Component, OnInit } from '@angular/core';
import { VeriffService } from './veriff.service';
import { AuthService } from '../user/auth.service';


@Component({
  selector: 'app-veriff',
  templateUrl: './veriff.component.html',
  styleUrls: ['./veriff.component.scss']
})
export class VeriffComponent implements OnInit {

  constructor(
    private veriffService: VeriffService,
    private authService: AuthService
  ) {} 

  startVerification(){
    let Persona = (window as any).Persona ; 
    const client = new Persona.Client({
  
      referenceId: "12233",
      templateId: 'itmpl_LkXEBoPJCiuESvnfNDrwciDoMrVe',
      environmentId: 'env_Lv2intUASo2CfFmLUfC2MbhaHpNe',
      onReady: () => client.open(),
      onComplete: ({ inquiryId, status, fields }) => {
        // Inquiry completed. Optionally tell your server about it.
        console.log(`Sending finished inquiry ${inquiryId} to backend`);
      },
      onCancel: ({ inquiryId, sessionToken }) => console.log('onCancel'),
      onError: (error) => console.log(error),
    });
  }
  ngOnInit() {
    
  }
//     this.veriffService.loadVeriffScripts()
//       .then(() => {
// 
//         this.authService.user.take(1).subscribe(user => {

//           
//           if (user && user.userId) {
//             this.veriffService.initializeVeriff(user.userId);
//           }

       
        
//       })
//     })
//       .catch(error => {
//         console.error('Error loading Veriff scripts:', error);
//       });
  
}


// WEBPACK FOOTER //
// ./src/app/veriff/veriff.component.ts